<template>
  <!--
  <div class="items">
    <p>{{ itemName }} => S${{ itemValue }}</p>
    <button @click.prevent="toggleToast">Add to Cart</button>
  </div>
  -->
  <div class="item">
    <div class="left flex">
      <span class="item-name">{{ itemName }}</span>
      <span class="item-value">S${{ itemValue }}</span>
    </div>
    <div class="right flex">
      <button
        @click.prevent="addedToCart"
        v-if="itemNotInCart"
        class="add-to-cart"
      >
        Add to Cart
      </button>
      <button
        @click.prevent="decreaseQuantity"
        v-if="!itemNotInCart"
        class="decrease-quantity"
      >
        -
      </button>
      <!--
      <input
        class="quantity"
        type="number"
        v-if="!itemNotInCart"
        :placeholder="`${this.quantity}`"
      />
      -->
      <button class="quantity" v-if="!itemNotInCart">
        {{ this.quantity }}
      </button>
      <button
        @click.prevent="increaseQuantity"
        v-if="!itemNotInCart"
        class="increase-quantity"
      >
        +
      </button>
    </div>
  </div>
</template>

<script>
/**
 * The Cart can be an array. In JS, we can handle multiple objects in
 * the same array, so it is more like a diverse array.
 *
 * The format could be :
 * Index 0 : The restaurant ID, this is to enforce order from unique restaurants (String)
 * Index 1 : Item 1 (String)
 * Index 2 : Price of Item 1 (Float)
 * Index 3 : Quantity of Item 1 (Int)
 *
 * And the trend continues.
 * Example : ["XYZ123ABC987", "Item 1", 2.5, 3, "Item 2", 3, 1];
 * We can observe the trend 1,2,3--4,5,6....
 */

export default {
  name: "RestaurantItem",
  props: ["restaurantDetails", "itemName", "itemValue", "mainCart"],
  data() {
    return {
      itemNotInCart: true,
      quantity: 0,
      itemHolder: [],
      sameRestaurantAddition: false,
    };
  },
  mounted() {
    // Make a boolean variable is updatble for checking if restaurant ids are same, if they r,then can, else show error
    if (
      this.restaurantDetails.id === this.mainCart[0] ||
      this.mainCart.length === 0
    ) {
      this.sameRestaurantAddition = true;
    }

    for (let i = 1; i < this.mainCart.length; i = i + 3) {
      if (this.mainCart[0] === this.restaurantDetails.id) {
        //if ((this, this.mainCart[i] === this.itemName)) {
        if (this.mainCart[i] === this.itemName) {
          this.itemNotInCart = false;
          this.quantity = this.mainCart[i + 2];
          return;
        }
      }
    }
  },
  methods: {
    updateCart() {
      if (this.sameRestaurantAddition) {
        this.itemHolder = [this.itemName, this.itemValue, this.quantity];
        this.$emit("item-updated", this.itemHolder);
        return;
      }
      // Incase Fallback
      this.cannotUpdateCart();
    },
    cannotUpdateCart() {
      this.$toast.warning(
        "Mixing Items From Two Different Restaurants? It is our dream too! But alas, The Algorithm Won't Allow!"
      );
      this.quantity = 0;
      this.itemNotInCart = true;
      this.$emit("item-cannot-be-updated-different-restaurants");
    },
    toggleToast() {
      this.$toast.success(`Added ${this.itemName} to Cart`, {
        icon: true,
        timeout: 1500,
        position: "top-center",
        //position: "bottom-center",
      });
    },
    addedToCart() {
      if (this.sameRestaurantAddition) {
        this.toggleToast();
        this.quantity++;
        this.itemNotInCart = false;
        this.updateCart();
        return;
      }
      this.cannotUpdateCart();
    },
    increaseQuantity() {
      if (this.sameRestaurantAddition) {
        this.quantity++;
        if (this.quantity > 10) {
          this.quantity = 10;
          this.$toast.warning(`Maximum Quantity Reached for ${this.itemName}`, {
            timeout: 1500,
            position: "top-center",
            //position: "bottom-center",
          });
          return;
        }
        this.updateCart();
        return;
      }
      this.cannotUpdateCart();
    },
    decreaseQuantity() {
      if (this.sameRestaurantAddition) {
        this.quantity--;
        if (this.quantity <= 0) {
          this.itemNotInCart = true;
          this.$toast.error(`Removed ${this.itemName} from Cart`, {
            timeout: 1500,
            position: "top-center",
            //position: "bottom-center",
          });
        }
        this.updateCart();
        return;
      }
      this.cannotUpdateCart();
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  gap: 16px;
  margin-bottom: 16px;
  border-radius: 20px;
  padding: 28px 32px;
  //background-color: rgb(255, 255, 235);
  //background-color: rgb(235, 235, 235);
  background-color: #f1f1f1;
  align-items: center;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: 0.35s;

  @media (min-width: 800px) {
    display: flex;
    flex: row;

    &:hover {
      transition: 0.35s;
      background-color: rgb(235, 247, 255);
    }
  }

  .left {
    display: flex;
    align-items: center;
    flex-basis: 80%;
    gap: 16px;

    span {
      flex: 1;
    }

    .item-name {
      font-size: 20px;
    }

    .item-value {
      text-align: right;
      font-size: 20px;
      @media (min-width: 800px) {
        text-align: center;
      }
    }
  }

  .right {
    display: flex;
    flex-basis: 40%;
    gap: 16px;
    justify-content: center;
    align-items: center;
    @media (min-width: 800px) {
      justify-content: flex-end;
    }

    /*
    button {
      //flex: 1;
    }

    input {
      //flex: 1;
    }
    */

    .add-to-cart {
      cursor: pointer;
      width: 140px;
      transition: 0.5s;

      @media (min-width: 800px) {
        &:hover {
          transition: 0.5s;
          background-color: #fff;
          color: #000;
        }
      }
    }

    .decrease-quantity {
      text-align: center;
      cursor: pointer;
      width: 50px;
      height: 50px;
      border-radius: 50px;
      background-color: rgb(255, 0, 60);
      border: 2px red solid;
      font-weight: 500;
    }

    .quantity {
      text-align: center;
      height: 50px;
      width: 50px;
      border-radius: 50px;
      // or greeen
      color: #fff;
      font-weight: 500;
      border: 2px #000 solid;
    }

    .increase-quantity {
      text-align: center;
      cursor: pointer;
      width: 50px;
      height: 50px;
      border-radius: 50px;
      background-color: rgb(80, 255, 80);
      border: 2px rgb(80, 255, 80) solid;
      font-weight: 500;
    }
  }
}

/*
.items {
  p {
    text-align: center;
  }
  button {
    display: block;
    margin: 10px auto;
  }
}
*/
</style>
